import { AxiosInstance } from "axios"
import {
    ArticleItem,
    BaseMerchantNewsArticle,
    ExternalMerchantNewsArticle,
    MerchantProductNewsArticle,
    NormalMerchantNewsArticle,
} from "./merchantNewsItemType"
import { StrictOmit } from "../../../../lib/lang"

export enum MerchantAdminNewsQuery {
    LIST = "merchant-admin-news",
    ARCHIVE_LIST = "merchant-admin-archive-news",
    ARTICLE_DETAILS = "merchant-admin-article",
}

export type FetchMerchantAdminNewsParam = Readonly<{
    merchantId: number
}>

export type FetchMerchantAdminNewsResponse = Readonly<{
    news: BaseMerchantNewsArticle[]
}>

export type CreateMerchantAdminNewsParam = Readonly<{
    merchantId: number
    article:
        | StrictOmit<NormalMerchantNewsArticle, "id" | "created" | "updated">
        | StrictOmit<ExternalMerchantNewsArticle, "id" | "created" | "updated">
        | StrictOmit<MerchantProductNewsArticle, "id" | "created" | "updated">
}>

export type DeleteMerchantAdminNewsParam = Readonly<{
    merchantId: number
    articleId: number
}>

export async function fetchMerchantAdminNews(
    { merchantId }: FetchMerchantAdminNewsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantAdminNewsResponse> {
    const url = `/merchants/${merchantId}/news?draft=true`

    const response = await axios.get(url, {
        params: {
            merchantId,
        },
        signal,
    })

    return response.data
}

export async function fetchMerchantAdminArchiveNews(
    { merchantId }: FetchMerchantAdminNewsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantAdminNewsResponse> {
    const url = `/merchants/${merchantId}/news?expired=true&active=false`

    const response = await axios.get(url, {
        params: {
            merchantId,
        },
        signal,
    })

    return response.data
}

type ServiceResponse = Readonly<{
    serviceResponse: {
        displayMessage: string
    }
}>
export type CreateArticleParam = Readonly<{
    article: ArticleItem
    merchantId: number
}>

export async function createMerchantAdminNews(
    { merchantId, article }: CreateArticleParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const response = await axios.post(
        `/merchants/${merchantId}/news`,
        {
            news: article,
        },
        {
            signal,
        },
    )
    return response.data
}
export async function deleteMerchantAdminNews(
    { merchantId, articleId }: DeleteMerchantAdminNewsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const response = await axios.delete(`/merchants/${merchantId}/news/${articleId}`, {
        signal,
    })
    return response.data
}

type FetchArticleParam = Readonly<{
    articleId: string
}>
export type FetchArticleResponse = Readonly<{
    news: ArticleItem
}>
export async function fetchArticle(
    { articleId }: FetchArticleParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchArticleResponse> {
    const url = `/news/${articleId}`

    const { data } = await axios.get(url, {
        signal,
    })
    return data
}

export type UpdateArticleParam = Readonly<{
    article: ArticleItem
    merchantId: number
    articleId: string
}>
export async function updateArticle(
    { article, merchantId, articleId }: UpdateArticleParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const { data } = await axios.post(
        `/merchants/${merchantId}/news/${articleId}`,
        {
            news: article,
        },
        {
            signal,
        },
    )
    return data
}
